export const baseUrl = '/simplehosting';
export const statePath = 'gandiReduxResourceSimplehosting';
export const hashString = str => String(str.split('').reduce((prevHash, currVal) => (prevHash << 5) - prevHash + currVal.charCodeAt(0), 0));
export function normalizeFqdn(fqdn) {
  return typeof fqdn === 'string' ? fqdn.toLowerCase() : fqdn;
}